import SubscriptionTokenResponse from "interfaces/response/SubscriptionTokenResponse";
import SubscriptionTokenRequest from "interfaces/request/SubscriptionTokenRequest";
import { getDataAsync, postDataAsync, putDataAsync } from "./PortalApi";

export const getTokensBySubscriptionIdAsync = async (
  subscriptionId: number
) => {
  const url = `Subscriptions/${subscriptionId}/Tokens`;
  return await getDataAsync<SubscriptionTokenResponse[]>(url);
};

export const createNewTokenAsync = (tokenDetail: SubscriptionTokenRequest) => {
  const url = "Subscriptions/Tokens";
  return postDataAsync<SubscriptionTokenRequest, SubscriptionTokenResponse>(
    url,
    tokenDetail
  );
};

export const updateTokenAsync = (tokenDetail: SubscriptionTokenRequest) => {
  const url = `Subscriptions/Tokens/${tokenDetail.id}`;
  return putDataAsync<SubscriptionTokenRequest, SubscriptionTokenResponse>(url, tokenDetail);
};

export const regenerateTokenAsync = (tokenId: number) => {
  const url = `Subscriptions/Tokens/${tokenId}/Generate`;
  return postDataAsync<any, SubscriptionTokenResponse>(url, null);
};

export const getTokenTagsByProductIdAsync = (productId: number) => {
  const url = `Products/${productId}/Subscriptions/TokenTags`;
  return getDataAsync<string[]>(url);
};
